class ShippingQuote extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('.shipping-input');
    this.button = this.querySelector('button[type="submit"]');
    this.loadingSpinner = this.button.querySelector('.loading__spinner');
    this.errorMessage = this.querySelector('.msg-error');
    this.address = this.querySelector('.address');
    this.shippingQuotes = this.querySelector('.shipping-quotes');
    this.baseUrl = window.Shopify?.routes?.root || '/';
    //Só existe na página de produto (ver product-info.liquid). No cart-drawer e na página do carrinho fica vazio.
    this.productFormId = this.dataset.productFormId || null;
    this.isBusy = false;
  }

  connectedCallback() {
    //Input Listener para aplicar a máscara do cep
    this.input.addEventListener('input', () => {
      // Remove tudo que não for dígito
      let maskedValue = this.input.value.replace(/\D/g, '');

      // Limita a 8 dígitos (sem o '-')
      if (maskedValue.length > 8) {
        maskedValue = maskedValue.substring(0, 8);
      }

      // Aplica a máscara: XXXXX-XXX (se tiver 5+ dígitos)
      if (maskedValue.length > 5) {
        maskedValue = maskedValue.replace(/^(\d{5})(\d{0,3})/, '$1-$2');
      }

      this.input.value = maskedValue;
    });

    //Acionado no clique - valida o cep digitado antes de iniciar
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      this.hideError();

      const value = this.input.value.trim();
      // Remove hífen para validação
      const cleanValue = value.replace(/-/g, '');

      // Confirma se tem 8 dígitos
      if (/^\d{8}$/.test(cleanValue)) {
        this.getShipping(cleanValue);
      } else {
        this.showError('CEP inválido! Deve ter 8 dígitos.');
      }
    });
  }

  //Controlam mensagens de erro
  hideError() {
    this.input.classList.remove('error');
    this.errorMessage.classList.add('hidden');
  }
  showError(msg) {
    this.input.classList.add('error');

    this.errorMessage.innerHTML = `
            <span>
                <strong>${msg}</strong>
            </span>
            `;

    this.errorMessage.classList.remove('hidden');
    this.address.classList.add('hidden');
    this.shippingQuotes.classList.add('hidden');
    this.hideLoading();
  }

  //Controlam visual do Carregamento
  hideLoading() {
    if (!this.loadingSpinner) return;

    this.loadingSpinner.classList.add('hidden');
    this.button.querySelector('span').classList.remove('hidden');
  }
  showLoading() {
    if (!this.loadingSpinner) return;

    this.loadingSpinner.classList.remove('hidden');
    this.button.querySelector('span').classList.add('hidden');
  }

  //Atualiza visual com informações do endereço - somente se for possível o preenchimento
  updateAddress(address) {
    let strAddress = '';

    if (address?.logradouro) strAddress += address.logradouro;
    if (address?.bairro) strAddress += strAddress !== '' ? `, ${address.bairro}` : address.bairro;
    if (address?.localidade) strAddress += strAddress !== '' ? ` - ${address.localidade}` : address.localidade;
    if (address?.uf) strAddress += strAddress !== '' ? `, ${address.uf}` : address.uf;

    if (strAddress !== '') {
      this.address.innerHTML = `<span>${strAddress}</span>`;
      this.address.classList.remove('hidden');
    } else {
      this.address.classList.add('hidden');
    }
  }

  //Renderiza as opções de frete
  renderShippingQuotes(shippingQuotes) {
    //Retira o resultado anterior (se houver) e esconde a div até que todos os itens sejam carregados
    this.shippingQuotes.textContent = '';
    this.shippingQuotes.classList.remove('hidden');

    //Para cada opção de frete - criar e inserir um <li> com as informações
    shippingQuotes.forEach((quote) => {
      const deliveryTime = quote.delivery_days[0] != 1 ? 'dias úteis' : 'dia útil';

      const price = quote.price > 0 ? `R$ ${quote.price.toString().replace('.', ',')}` : 'Grátis';

      //Modo de configurar nome para transportadora padrão
      let presentment_name = `<span class="shipping-carrier-title">
                    <strong>
                    ${quote.presentment_name.trim()}
                    </strong>
                </span>`;

      //Caso ela tenha retirada em loja
      //Talvez seja bom trocar o RETIRAR por algo que possamos alterar nas configurações do painel
      //Caso seja diferente em outra transportadora
      //Pior que acontece é o nome gigante, somente
      if (quote.presentment_name.includes('RETIRAR')) {
        const wordParts = quote.presentment_name.split('|');

        let temp = '';
        for (const [index, part] of wordParts.entries()) {
          if (part.includes('RETIRAR')) {
            temp += `<span class="shipping-carrier-title">
                                <strong>
                                ${part.trim()}
                                </strong>
                            </span>`;
            continue;
          }
          if (index > 1) {
            temp += `<span class="shipping-carrier-store-detail">${part.trim()}</span>`;
            continue;
          }
          temp += `<span class="shipping-carrier-store">${part.trim()}</span>`;
        }
        presentment_name = temp;
      }

      const item = `
                <li class="shipping-quote">
                    <div class="shipping-carrier">
                        ${presentment_name}
                        <small>${quote.delivery_days[0]} ${deliveryTime}</small>
                    </div>
                    <div class="shipping-price">
                        <span>
                            <strong>
                                ${price}
                            </strong>
                        </span>
                    </div>
                </li>
                `;
      this.shippingQuotes.insertAdjacentHTML('beforeend', item);
    });
  }

  //Lógica principal
  //REGRA: o valor do pedido (ex: frete grátis acima de R$800) só considera o que REALMENTE está no carrinho.
  // - Cart-drawer / página do carrinho: usa o carrinho real.
  // - Página de produto com itens no carrinho: usa o carrinho real (o produto da página NÃO entra na conta
  //   até o cliente clicar em "Adicionar ao carrinho").
  // - Página de produto com carrinho VAZIO: a Shopify só cota frete de carrinho, então o produto é
  //   adicionado por um instante, o frete é consultado e a linha é removida em seguida (finally).
  //   Como o carrinho estava vazio, o valor considerado é apenas o do próprio produto.
  async getShipping(cep) {
    if (this.isBusy) return;
    this.isBusy = true;

    try {
      //Controle visual (inicia loadingSpinner e esconde resultados anteriores)
      this.showLoading();
      this.shippingQuotes.classList.add('hidden');
      this.address.classList.add('hidden');

      //Pega o endereço para verificar se o mesmo existe
      //E para que o cliente possa confirmar que está correto
      const address = await this.getCEP(cep);
      if (!address || address?.erro) {
        this.showError('CEP informado é inválido.');
        return;
      }
      //Renderiza na tela
      this.updateAddress(address);

      //Valores - respeitando a regra descrita acima
      const shippingQuotes = await this.getQuotesForContext(cep, address.uf);

      if (!shippingQuotes || shippingQuotes.length === 0) {
        this.showError('Não encontramos opções de frete para este CEP.');
        return;
      }

      //Renderizar opções de frete e finalizar loadingSpinner
      this.renderShippingQuotes(shippingQuotes);
      this.hideLoading();
    } catch (e) {
      console.error('Error: ', e);
      this.showError(e?.userMessage || 'Erro: verifique o CEP e tente novamente.');
    } finally {
      this.isBusy = false;
    }
  }

  //Decide de onde vêm os itens usados na cotação
  async getQuotesForContext(cep, uf) {
    const productForm = this.productFormId ? document.getElementById(this.productFormId) : null;

    //Cart-drawer / página do carrinho: sempre o carrinho real
    if (!productForm) return this.getShippingQuote(cep, uf);

    //Página de produto: se já há itens no carrinho, o produto da página não entra na conta
    const cart = await this.getCart();
    if (cart.item_count > 0) return this.getShippingQuote(cep, uf);

    //Página de produto + carrinho vazio: cota somente o produto da página
    return this.getShippingQuoteForProduct(productForm, cep, uf);
  }

  async getCart() {
    const response = await fetch(`${this.baseUrl}cart.js`, { cache: 'no-store' });
    if (!response.ok) throw new Error(`Falha ao ler o carrinho (status ${response.status})`);
    return response.json();
  }

  //Adiciona o produto temporariamente (carrinho vazio), cota o frete e SEMPRE remove a linha adicionada
  async getShippingQuoteForProduct(productForm, cep, uf) {
    const formData = new FormData(productForm);
    const variantId = Number(formData.get('id'));
    const quantity = parseInt(formData.get('quantity'), 10) || 1;

    if (!variantId) {
      const err = new Error('Variante não selecionada');
      err.userMessage = 'Selecione as opções do produto para calcular o frete.';
      throw err;
    }

    let addedItem = null;
    try {
      const addResponse = await fetch(`${this.baseUrl}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        //_shipping_calc: propriedade oculta usada pelo interceptor de fetch para não validar variante/abrir o drawer
        body: JSON.stringify({ id: variantId, quantity, properties: { _shipping_calc: 'true' } }),
      });

      if (!addResponse.ok) {
        const err = new Error(`Falha ao simular produto (status ${addResponse.status})`);
        err.userMessage = 'Não foi possível calcular o frete para este produto agora.';
        throw err;
      }
      addedItem = await addResponse.json();

      return await this.getShippingQuote(cep, uf);
    } finally {
      if (addedItem) await this.removeSimulatedLine(addedItem, quantity);
    }
  }

  //Remove só o que foi adicionado na simulação (até 2 tentativas)
  async removeSimulatedLine(item, addedQuantity) {
    const remaining = Math.max((item.quantity || addedQuantity) - addedQuantity, 0);

    for (let attempt = 0; attempt < 2; attempt++) {
      try {
        const response = await fetch(`${this.baseUrl}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: remaining }),
        });
        if (response.ok) return;
      } catch (e) {
        console.error('Error ao remover item da simulação: ', e);
      }
    }
  }

  //Pega as opções de frete utilizando a própria Shopify através da AJAX API (https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates);
  //Exemplo de URL: cart/shipping_rates.json?shipping_address[zip]=CEP&shipping_address[country]=PAÍS&shipping_address[province]=ESTADO ou DISTRITO
  //O endpoint usa automaticamente os itens que já estão no carrinho da sessão atual.
  //cache: 'no-store' evita que o navegador sirva uma resposta antiga em cache depois que o
  //conteúdo do carrinho mudar (ex: cliente adiciona/remove item e recalcula o frete em seguida).
  //Poderia estar num Service em separado para melhor manutenção (shippingService)
  getShippingQuote(cep, province) {
    const paramsUrl = `cart/shipping_rates.json?shipping_address[zip]=${cep}&shipping_address[country]=BR&shipping_address[province]=${province}`;
    return fetch(`${this.baseUrl}${paramsUrl}`, { cache: 'no-store' })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Falha ao consultar frete (status ${response.status})`);
        }
        return response.json();
      })
      .then((data) => {
        if (data?.shipping_rates?.length > 0) {
          return data.shipping_rates;
        }
        return null;
      })
      .catch((e) => {
        console.error('Error: ', e);
        return null;
      });
  }

  //Faz requisição a VIACEP para validação e utilizar endereço do cliente (estado/distrito)
  //Poderia ser utilizada a BRASILAPI, mas os atributos seriam outros, ex: resultado.estado seria resultado.province
  //Para realizar a troca deve ser reescrita essa parte no getShippingQuotes ou fazer com que seja genérica o bastante para ambos.
  //Poderia estar num Service em separado para melhor manutenção (AddressService?)
  getCEP(value) {
    return fetch(`https://viacep.com.br/ws/${value}/json/`, { cache: 'no-store' })
      .then((response) => response.json())
      .then((data) => {
        if (!data.erro) {
          return data;
        }
      })
      .catch((e) => console.error('Error na validação ', e));
  }
}

//Inicialização padrão de elemento HTML personalizado
if (!customElements.get('shipping-quote')) {
  try {
    customElements.define('shipping-quote', ShippingQuote);
  } catch (err) {
    console.error('Element already defined:', err);
  }
}
